/*
 * @Descripttion:
 * @Author: weitongxue
 */
import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import { UserItem, IFuzzyQueryUserBySSOParams, IUserSSOItem } from './type.d';

// 根据关键字检索用户
export const fuzzyQueryUser = (keyword: string) => {
  const url = `/sso-center/web/v1/user/userInfo?keyword=${keyword}`;
  return http.get<UserItem[]>({
    url,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

// 根据关键字检索用户 包含离职&停用用户
export const fuzzyQueryAllUser = (keyword: string) => {
  const url = `/authManage/user/search/${keyword}`;
  return http.get<UserItem[]>({
    url,
  });
};

// 根据关键字查询SSO用户
export const fuzzyQueryUserBySSO = (data: IFuzzyQueryUserBySSOParams) => {
  const url = '/sso-center/admin/users/query-user-by-username-and-companyId';
  return http.post<IUserSSOItem[]>({
    url,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
